import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { UrlTree } from '@angular/router';
import { GuestAuthService } from 'src/app/services/guest-auth.service';
import { StateService } from 'src/app/services/state.service';
import { UserService } from 'src/app/services/user.service';

@Injectable({
  providedIn: 'root',
})
export class ViewGalleryIdentificationGuard {
  constructor(
    private userService: UserService,
    private state: StateService,
    private guestAuthService: GuestAuthService,
    @Inject(PLATFORM_ID) private platformId: string
  ) {}

  async canActivate(): Promise<UrlTree | boolean> {
    if (isPlatformServer(this.platformId)) return true;
    await this.guestAuthService.init();
    const userLoggedIn = !!(await this.userService.getUser());
    const guestLoggedIn = !!this.state.guestAuthToken;
    if (userLoggedIn || guestLoggedIn) return true;
    this.guestAuthService.prepAnonymousGuest();
    return true;
  }
}
